import { render, staticRenderFns } from "./InvoiceDetailView.vue?vue&type=template&id=6c7260eb"
import script from "./InvoiceDetailView.vue?vue&type=script&lang=ts"
export * from "./InvoiceDetailView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports